import Label from "../common/Label";
import Input from "../common/Input";
import Button from "../common/Button";
import { useNavigate } from "react-router-dom";
import api from "../../api/ApiService";
import { useState } from "react";
import { Spinner } from "../../icons/CommonIcons";
import { INVEST_UK_WEBSITE_URL } from "../../config/apiConfig";
import { useLanguage } from "../LanguageProvider/LanguageProvider";
import { useAuth } from "./AuthProvider";
import { scriptRegex } from "../../utils/utils";

const Loginform = () => {
  const navigate = useNavigate();
  const [cafId, setCafId] = useState("");
  const [cafIdError, setCafIdError] = useState(null);
  const [verifying, setVerifying] = useState(false);
  const { language, setLanguage } = useLanguage();
  const { setTokenGenerated, setUserType } = useAuth();

  const handleSubmit = async () => {
    try {
      setCafIdError("");

      if (!cafId) {
        setCafIdError({
          en: "CAF ID is required",
          hi: "सीएएफ आईडी आवश्यक है",
        });
        return;
      }
      setVerifying(true);

      //await api.initCsrf();

      const res = await api.post("/cafId/match", {
        caf_id: cafId,
      });

      if (res.status !== 200 && res?.message?.en !== "OTP already sent. Please check email.") {
        setCafIdError({
          en: res?.message?.en || "Unable to process request",
          hi: res?.message?.hi || "अनुरोध संसाधित करने में असमर्थ",
        });
        return;
      }
      setUserType("user");
      setTokenGenerated(false);
      setCafId("");
      navigate("/validate-otp", { state: { cafId } });
    } catch (error) {
      setCafIdError({
        en: "Something went wrong",
        hi: "कुछ गलत हो गया",
      });
    } finally {
      setVerifying(false);
    }
  };

  return (
    <>
      <div>
        <Label htmlFor="cafId" className="text-md pb-2 float-left">
          {language ? "यदि आपके पास सीएएफ आईडी है" : "If you have CAF ID"}
        </Label>
        <Input
          type="text"
          id="cafId"
          name="cafId"
          value={cafId}
          placeholder={language ? "सीएएफ आईडी दर्ज करें" : "Enter CAF ID"}
          required
          className="w-full border rounded-md px-3 py-2"
          onChange={(e) => {
            if (!scriptRegex.test(e.target.value)) {
              setCafIdError(null);
              setCafId(e.target.value);
            }
          }}
        />
        {cafIdError &&
          (language ? cafIdError.hi : cafIdError.en)
            ?.split("\\n")
            .map((line, idx) => (
              <span key={idx} className="text-red-500 text-sm block">
                {line}
              </span>
            ))}
        {verifying ? (
          <Button className="w-full bg-btn font-semibold py-2 rounded-md mt-5 flex items-center justify-center gap-2">
            {language ? "जाँच रहे हैं" : "Validating"}
            <Spinner />
          </Button>
        ) : (
          <Button
            onClick={handleSubmit}
            className="w-full bg-btn font-semibold py-2 rounded-md mt-5"
          >
            {language ? "जाँचें" : "Validate"}
          </Button>
        )}
      </div>
      <div className="text-center">
        <span>
          {" "}
          {language
            ? "क्या आपके पास सीएएफ आईडी नहीं है?"
            : "Don't have a CAF ID?"}{" "}
        </span>
        <Button
          onClick={() =>
            window.open(INVEST_UK_WEBSITE_URL, "_blank", "noopener,noreferrer")
          }
          className="text-sm text-theme-color"
        >
          {language ? "यहां रजिस्टर करें" : "Register here"}
        </Button>
      </div>
    </>
  );
};

export default Loginform;
